// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Signika+Negative:300,400,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
/* Please define all colors in rgb format so any 
transparency effects can be applied via a uniform 
string replace operation in code */
/* Please define all times in seconds to any transition
effects can be applied via a uniform string replace
operation in code */
:root {
  --tp-base-font-family: "Montserrat", sans-serif !important;
  --color-bg: rgb(252, 252, 252);
  --color-fg: rgb(0, 0, 0);
  --color-hover: rgb(179, 30, 0);
  --blur-background: blur(10px);
  --transition-time: 0.5s;
  --padding: 1rem;
  --offset: 20vw;
  --button-bg: rgb(131, 12, 0);
  --button-fg: rgba(255, 255, 255);
  --border-color: rgba(255, 255, 255);
  --button-border-color: rgba(255, 255, 255, 0.40);
  --badge-bg-color: rgb(131, 12, 0);
  --badge-fg-color: rgb(0,0,0);
  --color-fg-opacity: rgba(0, 0, 0, 0.4);
  --badge-fg-color: rgba(255, 255, 255);
  --color-bg-opacity: rgba(252, 252, 252, 0.2);
}

[data-theme=light] {
  --color-bg: rgb(252, 252, 252);
  --color-fg: rgb(0, 0, 0);
  --color-fg-opacity: rgba(0, 0, 0, 0.3);
  --color-bg-opacity: rgba(0, 0, 0, 0.1);
  --color-hover: rgb(179, 30, 0);
  --border-color: rgba(0, 0, 0, 0.40);
}

[data-theme=dark] {
  --color-bg: rgb(18, 18, 18);
  --color-fg: rgb(252, 252, 252);
  --color-fg-opacity: rgba(252, 252, 252, 0.2);
  --color-bg-opacity: rgba(0, 0, 0, 0.3);
  --color-hover: rgb(163, 65, 45);
  --border-color: rgba(255, 255, 255, 0.50);
}

html {
  scroll-behavior: smooth;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Signika Negative", sans-serif, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg);
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body.hidePanel .TileManager .TileManager,
body.hidePanel .TileManager .TileManager .slider {
  visibility: hidden !important;
  height: 0px !important;
  padding: 0px !important;
}

body.hidePanel .Header,
body.hidePanel .tile-manager-title,
body.hidePanel .Footer {
  display: none !important;
}

h3 {
  font-family: "Montserrat", sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* ContentTile styles */
.ContentTile_ {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ContentTile_ h1 {
  width: 70%;
  text-align: center;
}
.ContentTile_ h1,
.ContentTile_ span {
  display: inline;
  flex-direction: row;
  justify-content: space-around;
  font-family: "Montserrat", sans-serif;
}
@media (max-width: 767px) {
  .ContentTile_ h1,
  .ContentTile_ span {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile_ h1,
  .ContentTile_ span {
    font-size: 2.5rem;
    line-height: 3rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile_ h1,
  .ContentTile_ span {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}
.ContentTile_ h2 {
  font-family: "Montserrat", sans-serif;
}
@media (max-width: 767px) {
  .ContentTile_ h2 {
    font-size: 1rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile_ h2 {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile_ h2 {
    font-size: 2.25rem;
    line-height: 2.75rem;
  }
}
.ContentTile_ h3 {
  font-family: "Montserrat", sans-serif;
  font-size: 1.2rem;
}
.ContentTile_ hr {
  width: 70%;
  height: 1px;
  background-color: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.ContentTile_ em, .ContentTile_ em * {
  color: #830C00;
  font-style: normal;
}
.ContentTile_ p {
  display: block;
  text-align: center;
  width: 80%;
}
@media (max-width: 767px) {
  .ContentTile_ p {
    font-size: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile_ p {
    font-size: 1.1rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile_ p {
    font-size: 1.25rem;
  }
}
.ContentTile_ section {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 1rem;
}
@media (max-width: 767px) {
  .ContentTile_ section {
    flex-direction: column;
  }
}
.ContentTile_ small {
  font-size: 0.8rem;
  color: var(--color-fg-opacity);
}
.ContentTile_ video {
  object-fit: cover;
}

/*Videos Tile container styles*/
.video__section {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video__section .VideoTile {
  margin: 0;
}

.video__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.video__section--content {
  margin: 1rem;
}

@media only screen and (max-width: 600px) {
  .video__container {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .video__container .content-container .content-headline {
    font-size: 2rem;
  }
}
/* These styles are for Text to motion tile*/
.text-to-motion-sample-slide {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.text-to-motion-sample-slide .image-container img {
  width: 100%;
}

.text-to-motion-sample-slide .content-container {
  width: 100%;
  align-items: flex-start;
  text-align: left;
}

.text-to-motion-sample-slide .content-container .content-headline {
  font-size: 3rem;
  align-items: flex-start;
}

.text-to-motion-sample-slide .content-container .content-description {
  align-items: flex-start;
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .text-to-motion-sample-slide {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .text-to-motion-sample-slide .content-container .content-headline {
    font-size: 2rem;
  }
}
/*These styles are for For Developer Tile set*/
.tile-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.tile-content .tile-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.8rem;
}

.tile-content .tile-head i {
  font-size: 5rem;
}

.tile-content .tile-head div:last-child {
  font-size: 1rem;
}

.tile-content .tile-lable {
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
}

/*These styles are for Contact Tile set*/
.contact-section {
  display: flex;
  padding: 1.5rem 0;
  gap: 1rem;
}
@media only screen and (max-width: 600px) {
  .contact-section {
    flex-direction: column;
  }
}

.contact-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  height: 100%;
  gap: 1rem;
}

.contact-container .tile-content,
.contact-container .tile-head {
  align-items: start;
}

.tile-content .tile-head h3 {
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  margin: 0;
}

.tile-content .tile-lable p {
  font-size: 1rem;
  font-weight: normal;
  text-align: left;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA,0BAAA;ACKA;;kCAAA;AAIA;;mBAAA;AAIA;EACE,0DAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,gDAAA;EACA,iCAAA;EACA,4BAAA;EACA,sCAAA;EACA,qCAAA;EACA,4CAAA;AAHF;;AAMA;EACE,8BAAA;EACA,wBAAA;EACA,sCAAA;EACA,sCAAA;EACA,8BAAA;EACA,mCAAA;AAHF;;AAMA;EACE,2BAAA;EACA,8BAAA;EACA,4CAAA;EACA,sCAAA;EACA,+BAAA;EACA,yCAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,SAAA;EACA,kDAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AAHF;;AAMA;;EAEE,6BAAA;EACA,sBAAA;EACA,uBAAA;AAHF;;AAMA;;;EAGE,wBAAA;AAHF;;AAMA;EACE,qCAAA;AAHF;;AAMA;EACE,+EAAA;AAHF;;AAMA,uBAAA;AAEA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAME;EACE,UAAA;EACA,kBAAA;AAJJ;AAOE;;EAEE,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,qCAAA;AALJ;ADpGE;ECoGA;;IAQI,eAAA;IACA,mBAAA;EAHJ;AACF;ADpGE;EC6FA;;IAaI,iBAAA;IACA,iBAAA;EADJ;AACF;ADpGE;ECsFA;;IAkBI,eAAA;IACA,mBAAA;EACJ;AACF;AAEE;EACE,qCAAA;AAAJ;AD5HE;EC2HA;IAII,eAAA;IACA,oBAAA;EACJ;AACF;AD3HE;ECoHA;IASI,eAAA;IACA,mBAAA;EAEJ;AACF;AD1HE;EC6GA;IAcI,kBAAA;IACA,oBAAA;EAGJ;AACF;AACE;EACE,qCAAA;EACA,iBAAA;AACJ;AAEE;EACE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,2CAAA;AAAJ;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;AAIE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AAFJ;ADjKE;ECgKA;IAMI,eAAA;EADJ;AACF;AD/JE;ECyJA;IAUI,iBAAA;EAAJ;AACF;AD7JE;ECkJA;IAcI,kBAAA;EACJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AACJ;ADtLE;ECiLA;IAMI,sBAAA;EAGJ;AACF;AAAE;EACE,iBAAA;EACA,8BAAA;AAEJ;AACE;EACE,iBAAA;AACJ;;AAGA,+BAAA;AAEA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE;IACE,0BAAA;IACA,aAAA;EADF;EAIA;IACE,eAAA;EAFF;AACF;AAKA,4CAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,eAAA;EACA,uBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,gBAAA;AAHF;;AAOA;EACE;IACE,0BAAA;IACA,aAAA;EAJF;EAOA;IACE,eAAA;EALF;AACF;AAQA,8CAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA,wCAAA;AAEA;EACE,aAAA;EACA,iBAAA;EACA,SAAA;AARF;AASE;EAJF;IAKI,sBAAA;EANF;AACF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;AANF;;AASA;;EAEE,kBAAA;AANF;;AASA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AANF;;AASA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AANF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use './styles';\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Signika+Negative:300,400,600&display=swap');\n\n/* Please define all colors in rgb format so any \ntransparency effects can be applied via a uniform \nstring replace operation in code */\n\n/* Please define all times in seconds to any transition\neffects can be applied via a uniform string replace\noperation in code */\n\n:root {\n  --tp-base-font-family: \"Montserrat\", sans-serif !important;\n  --color-bg: rgb(252, 252, 252);\n  --color-fg: rgb(0, 0, 0);\n  --color-hover: rgb(179, 30, 0);\n  --blur-background: blur(10px);\n  --transition-time: 0.5s;\n  --padding: 1rem;\n  --offset: 20vw;\n  --button-bg: rgb(131, 12, 0);\n  --button-fg: rgba(255, 255, 255);\n  --border-color: rgba(255, 255, 255);\n  --button-border-color: rgba(255, 255, 255, 0.40);\n  --badge-bg-color:  rgb(131, 12, 0);\n  --badge-fg-color:  rgb(0,0,0);\n  --color-fg-opacity: rgba(0, 0, 0, 0.4);\n  --badge-fg-color:  rgba(255, 255, 255);\n  --color-bg-opacity: rgba(252, 252, 252, 0.2);\n}\n\n[data-theme=\"light\"] {\n  --color-bg: rgb(252, 252, 252);\n  --color-fg: rgb(0, 0, 0);\n  --color-fg-opacity: rgba(0, 0, 0, 0.3);\n  --color-bg-opacity: rgba(0, 0, 0, 0.1);\n  --color-hover: rgb(179, 30, 0);\n  --border-color: rgba(0, 0, 0, 0.40);\n}\n\n[data-theme=\"dark\"] {\n  --color-bg: rgb(18, 18, 18);\n  --color-fg: rgb(252, 252, 252);\n  --color-fg-opacity: rgba(252, 252, 252, 0.2);\n  --color-bg-opacity: rgba(0, 0, 0, 0.3);\n  --color-hover: rgb(163, 65, 45);\n  --border-color: rgba(255, 255, 255, 0.50);\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Signika Negative\", sans-serif, Arial;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-bg);\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\nbody.hidePanel .TileManager .TileManager,\nbody.hidePanel .TileManager .TileManager .slider {\n  visibility: hidden !important;\n  height: 0px !important;\n  padding: 0px !important;\n}\n\nbody.hidePanel .Header,\nbody.hidePanel .tile-manager-title,\nbody.hidePanel .Footer {\n  display: none !important;\n}\n\nh3 {\n  font-family: \"Montserrat\", sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ContentTile styles */\n\n.ContentTile_ {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  h1 {\n    width: 70%;\n    text-align: center;\n  }\n\n  h1,\n  span {\n    display: inline;\n    flex-direction: row;\n    justify-content: space-around;\n    font-family: \"Montserrat\", sans-serif;\n\n    @include styles.mobile {\n      font-size: 2rem;\n      line-height: 2.5rem;\n    }\n\n    @include styles.tablet {\n      font-size: 2.5rem;\n      line-height: 3rem;\n    }\n\n    @include styles.desktop {\n      font-size: 3rem;\n      line-height: 3.5rem;\n    }\n  }\n\n  h2 {\n    font-family: \"Montserrat\", sans-serif;\n\n    @include styles.mobile {\n      font-size: 1rem;\n      line-height: 1.25rem;\n    }\n\n    @include styles.tablet {\n      font-size: 2rem;\n      line-height: 2.5rem;\n    }\n\n    @include styles.desktop {\n      font-size: 2.25rem;\n      line-height: 2.75rem;\n    }\n\n  }\n\n  h3 {\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 1.2rem;\n  }\n\n  hr {\n    width: 70%;\n    height: 1px;\n    background-color: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.20);\n  }\n\n  em, em * {\n    color: #830C00;\n    font-style: normal;\n  }\n\n  p {\n    display: block;\n    text-align: center;\n    width: 80%;\n\n    @include styles.mobile {\n      font-size: 1rem;\n    }\n\n    @include styles.tablet {\n      font-size: 1.1rem;\n    }\n\n    @include styles.desktop {\n      font-size: 1.25rem;\n    }\n  }\n  section {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    padding: 1rem;\n    @include styles.mobile {\n      flex-direction: column;\n    }\n  }\n\n  small {\n    font-size: 0.8rem;\n    color: var(--color-fg-opacity);\n  }\n\n  video {\n    object-fit: cover;\n  }\n}\n\n/*Videos Tile container styles*/\n\n.video__section {\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.video__section  .VideoTile {\n  margin: 0;\n}\n\n.video__container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 2rem;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.video__section--content {\n  margin: 1rem;\n}\n\n@media only screen and (max-width: 600px) {\n  .video__container {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .video__container .content-container .content-headline {\n    font-size: 2rem;\n  }\n}\n\n/* These styles are for Text to motion tile*/\n.text-to-motion-sample-slide {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 2rem;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.text-to-motion-sample-slide .image-container img {\n  width: 100%;\n}\n\n.text-to-motion-sample-slide .content-container {\n  width: 100%;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.text-to-motion-sample-slide .content-container .content-headline {\n  font-size: 3rem;\n  align-items: flex-start;\n}\n\n.text-to-motion-sample-slide .content-container .content-description {\n  align-items: flex-start;\n  text-align: left;\n}\n\n\n@media only screen and (max-width: 600px) {\n  .text-to-motion-sample-slide {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .text-to-motion-sample-slide .content-container .content-headline {\n    font-size: 2rem;\n  }\n}\n\n/*These styles are for For Developer Tile set*/\n\n.tile-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.tile-content .tile-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: .5rem;\n  font-size: 1.8rem;\n}\n\n.tile-content .tile-head i {\n  font-size: 5rem;\n}\n\n.tile-content .tile-head div:last-child {\n  font-size: 1rem;\n}\n\n.tile-content .tile-lable {\n  font-size: 1.2rem;\n  font-style: normal;\n  font-weight: 700;\n}\n\n/*These styles are for Contact Tile set*/\n\n.contact-section {\n  display: flex;\n  padding: 1.5rem 0;\n  gap: 1rem;\n  @media only screen and (max-width: 600px) {\n    flex-direction: column;\n  }\n}\n\n.contact-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem;\n  height: 100%;\n  gap: 1rem;\n}\n\n.contact-container .tile-content, \n.contact-container .tile-head {\n  align-items: start;\n}\n\n.tile-content .tile-head h3 {\n  font-size: 1.2rem;\n  font-style: normal;\n  font-weight: 700;\n  text-align: left;\n  margin: 0;\n}\n\n.tile-content .tile-lable p {\n  font-size: 1rem;\n  font-weight: normal;\n  text-align: left;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
